// extracted by mini-css-extract-plugin
export default {"Parentdiv":"ProgressBar_Parentdiv__xajJl","Childdiv":"ProgressBar_Childdiv__dwhet"};